import { useMutation, useQuery } from '@tanstack/react-query';
import { getCredits, startCreditCheckout } from '../../../api/Credits/credits';
import { CreditsInfo } from '../../../utility/credits';

export function useCredits(enabled = true) {
  const query = useQuery({ queryKey: [ 'credits' ], queryFn: () => getCredits(), enabled, retry: false });
  return { credits: (query.data?.data as CreditsInfo) || null, isLoading: query.isLoading, error: query.error };
}

export function useCreditCheckout() {
  return useMutation({
    mutationFn: ({ packageKey, quantity }: { packageKey: string; quantity?: number }) => startCreditCheckout(packageKey, quantity),
  });
}
